<template>
  <div class="container">
    <div class="main">
      <div class="title">
        <div class="title_name"></div>
      </div>

      <div style="margin-bottom:32px">
        <el-image
          style="width:296px;margin-left:48px"
          :src="require('@/assets/image/brandClassroom/BrakepadsClassroomPage/BrakepadsClassroomPage1/img1.png')"
          fit="fit">
        </el-image>
      </div>
      <div class="clear">
        <el-image
          style="width:1px;margin-right:24px;float:left;margin-left:48px"
          :src="require('@/assets/image/brandClassroom/BrakepadsClassroomPage/BrakepadsClassroomPage1/img2.png')"
          fit="fit">
        </el-image>
        <el-image
          style="width:734px;margin-bottom:27px;float:left"
          :src="require('@/assets/image/brandClassroom/BrakepadsClassroomPage/BrakepadsClassroomPage1/img3.png')"
          fit="fit">
        </el-image>
        <el-image
          style="width:292px;float:left;margin-right:20px"
          :src="require('@/assets/image/brandClassroom/BrakepadsClassroomPage/BrakepadsClassroomPage1/img4.png')"
          fit="fit">
        </el-image>
        <el-image
          style="width:294px;float:left"
          :src="require('@/assets/image/brandClassroom/BrakepadsClassroomPage/BrakepadsClassroomPage1/img5.png')"
          fit="fit">
        </el-image>
      </div>


    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return { 

      }
    }
  }
</script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brandClassroom/BrakepadsClassroom/img1.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding: 40px 42px 40px 42px; 
  box-sizing: border-box;
}

.title_name {
  height: 28px;
  width:  86px;
  background: url('~@/assets/image/brandClassroom/BrakepadsClassroom/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}




</style>